import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SyncComponent } from './Sync/Sync.component';
import { LoginComponent } from './login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from '../shared/language-switcher/language-switcher.component';



@NgModule({
  declarations: [
    PagesComponent,
    SyncComponent,
    LoginComponent,
    LanguageSwitcherComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ]
})
export class PagesModule { }

